import { combineEpics } from 'redux-observable'

import balanceAndRechargesEpic from '~/balance/store/balance.epics'
import barringEpics from '~/barrings/store/barring.epics'
import bonusEpics from '~/bonus/store/bonus.epics'
import consumptionEpics from '~/consumptions/store/consumption.epics'
import customerEpics from '~/customer/store/customer.epics'
import discountEpics from '~/discounts/store/discount.epics'
import energyContractEpics from '~/energyContract/store/energyContract.epics'
import permissionsEpics from '~/permissions/store/permissions.epics'
import serviceEpics from '~/services/store/service.epics'
import subscriptionDetailEpics from '~/subscriptionDetail/store/subscriptionDetail.epics'

const rootEpic = combineEpics(
  ...Object.values(balanceAndRechargesEpic),
  ...Object.values(barringEpics),
  ...Object.values(customerEpics),
  ...Object.values(consumptionEpics),
  ...Object.values(discountEpics),
  ...Object.values(energyContractEpics),
  ...Object.values(permissionsEpics),
  ...Object.values(serviceEpics),
  ...Object.values(subscriptionDetailEpics),
  ...Object.values(bonusEpics),
  ...Object.values(subscriptionDetailEpics),
)

export type RootEpic = typeof rootEpic

export default rootEpic
